import React from 'react'
import './subjects.css'
import GridContainer from '../../../../core/components/gridcontainer/GridContainer'
import illo2 from '../../../../core/img/homepage/expii_illo2_v2.png'
import dc from '../../../../core/img/homepage/dc.svg'
import slope from '../../../../core/img/homepage/slope.svg'
import solve from '../../../../core/img/homepage/solve.png'
import {UniLink} from '../../../../core/components/unilink/index'
import {subjectToImageLight} from '../../../../core/less/SubjectToImage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const underConstructionTopicsRow1 = [
  4712,
  752, 
  1,
  5525,
]

const underConstructionTopicsRow2 = [
  7954,
  1618,
  9213,
  1943
]

const SubjectsContainer = ({history, titles}) => {
  return (
    <div>
      <GridContainer>
        <div className='subjects-card2'>
          <h2>Explore Original Content</h2>
          <div className='card2-tile-container'>
            <div className='card2-tile'>
              <img className='' src={ dc } alt='' />
              <h3>Daily Challenge</h3>
              <p>
                Math lessons for middle school students that develop creative thinking through an innovative teaching style.
              </p>
              <a href="https://daily.poshenloh.com/">Visit Daily Challenge</a>
            </div>
            <div className='card2-tile'>
              <img className='' src={ slope } alt='' />
              <h3>Project Spark</h3>
              <p>
                Our video content expands beyond the traditional to develop imaginative content that connects with learners.
              </p>
              <a href="https://www.expii.com/spark">Learn more about Project Spark</a>
            </div>
            <div className='card2-tile'>
              <img className='' src={ solve } alt='' />
              <h3>Expii Solve</h3>
              <p>
                Fun, thought provoking, interactive math puzzles shown through current events and pop culture.
              </p>
              <a href="https://www.expii.com/solve">Push your knowledge</a>
            </div>
          </div>
        </div>
      </GridContainer>
      <div className='subjects__band3'>
        <GridContainer>
          <div className='subjects-card3'>
            <div className='subjects-card3-left'>
              <img className='' src={ illo2 } alt='' />
            </div>
            <div>
              <h2>Become Part of the Expii Community</h2>
              <p>
                Connect with us on any (or all) of our social media platforms.
              </p>
              <div>
                <div className='subjects-card3-links'>
                  <UniLink
                    target='_blank'
                    href='https://www.facebook.com/expii/'
                    rel='noopener'
                  >
                    <FontAwesomeIcon icon={['fab', 'facebook-f']} />
                  </UniLink>  
                  <UniLink
                    target='_blank'
                    href='https://www.instagram.com/expii_/'
                    rel='noopener'
                  >
                    <FontAwesomeIcon icon={['fab', 'instagram']} />
                  </UniLink>
                  <UniLink
                    target='_blank'
                    href='https://youtube.com/expii'
                    rel='noopener'
                  >
                    <FontAwesomeIcon icon={['fab', 'youtube']} />
                  </UniLink>
                  <UniLink
                    target='_blank'
                    href='http://eepurl.com/cmTSrf'
                    rel='noopener'
                  >
                    <FontAwesomeIcon icon={['fa', 'envelope']} />
                  </UniLink>
                </div>
              </div>
            </div>
          </div>
        </GridContainer>
      </div>
      <div className='subjects-band4'>
        <GridContainer>
          <div className='subjects-card4'>
            <div className='subjects-card4-left'>
              <h2>Subjects in Development</h2>
              <p>We have eight subjects in early stages of development. Volunteers laid the foundation. Our team is perfecting each lesson based on your input.</p>
            </div>
            <div className='subjects-card4-right'>
              <div className='subjects__other-subjects-container'>
                {
                  underConstructionTopicsRow1.map(s => (
                    <div key={s} className='subject-bar__subject'>
                      <UniLink
                        to={`/t/${s}`}
                      >
                        <img className='subject-bar__subject-image' src={subjectToImageLight[s]} alt='' />
                      </UniLink>
                      <span className='subject-bar__subject-name'>{titles[s]}</span>
                    </div>
                  ))
                }
              </div>
              <div className='subjects__other-subjects-container'>
                {
                  underConstructionTopicsRow2.map(s => (
                    <div key={s} className='subject-bar__subject'>
                      <UniLink
                        to={`/t/${s}`}
                      >
                        <img className='subject-bar__subject-image' src={subjectToImageLight[s]} alt='' />
                      </UniLink>
                      <span className='subject-bar__subject-name'>{titles[s]}</span>
                    </div>
                  ))
                }
              </div>
            </div>    
          </div>
        </GridContainer>
      </div>
    </div>
  )
}

export default SubjectsContainer



// WEBPACK FOOTER //
// ./src/domains/home/subjects/components/SubjectsContainer.js